import React, {useState} from 'react';
import { Col, Dropdown, Form, Row } from 'react-bootstrap';
import { Button, InputGroup } from 'react-bootstrap';

export default function SchemeListForm({
  selCategories, categories, handleCheckboxChange, 
  selLaunchGroups, launchGroups, handleLaunchGroupChange,
  type, setType, subCategories,
  investPlanOption, setInvestPlanOption, investPlanOptions,
  pageSize, setPageSize, setCurrentPage, 
  parentClearNameSearch, parentHandleNameSearch, parentSearchTerm,
}) {
   
    function NameFilter({parentSearchTerm, parentHandleNameSearch, parentClearNameSearch}) {
        const [searchText, setSearchText] = useState(parentSearchTerm); // searchTerm, onSearchTermChange, 

        const clearNameSearch = (event) => {
            event.preventDefault();
            // console.log("*** Inside clearNameSearch");

            parentClearNameSearch('');
        }

        const handleNameSearch = (e) => {
            e.preventDefault();
            // console.log("*** Inside clearNameSearch");

            parentHandleNameSearch(searchText);
        }
        const OnValueChange = (e) => { e.preventDefault(); setSearchText(e.target.value)} 

        return (
            <InputGroup>
                <Form.Control
                    type="search"
                    placeholder="Scheme Search..."
                    aria-label="SchemeSearch"
                    aria-describedby="search-btn"
                    className="me-1" // Remove default border to use Group border border-0 shadow-none
                    value={searchText}
                    onChange={OnValueChange}
                />
                {parentSearchTerm && (
                    <Button 
                    variant="outline-secondary" 
                    onClick={clearNameSearch}
                    aria-label="Clear search"
                    >
                    <i className="bi bi-x-lg me-1"></i>X
                    </Button>
                )}
                <Button variant="outline-secondary" id="button-addon2" onClick={handleNameSearch}>
                    Search
                </Button>
            </InputGroup>
    )};

// Details? Alternates? Similar
  return (
    <div className="mb-1 mt-1">
        <Row style={{fontSize:'0.90rem'}} className="align-items-center" >
            <Col xs={1} className="pe-0">
                <Form.Text className="border border-info" id="{investPlanOption['key']}" style={{ width: '100%'}}><b>{investPlanOption['value']}</b></Form.Text>
            </Col>
            <Col xs={2}>
                <Form.Label style={{fontSize:'0.80rem'}}>Scheme Details, Alternates, Similar ... <div><b>Click</b> <u>Scheme Name</u>.</div></Form.Label>
            </Col>
            <Col xs={1}>
                <Dropdown className="mx-0" style={{ width: '100%' }}>
                    <Dropdown.Toggle variant="secondary" id="dropdown-multi-select" className="w-100 text-start d-flex justify-content-between align-items-center">
                    {selCategories.length > 0 ? `${selCategories.length} Categories` : 'Select Categories'}
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{ width: '100%' }}>
                    {categories.map((category) => (
                        <Form.Check
                        key={category.scheme_category_id}
                        type="checkbox"
                        id={`checkbox-${category.scheme_category_id}`}
                        label={category.scheme_category_name}
                        value={category.scheme_category_id}
                        checked={selCategories.includes(category.scheme_category_id)}
                        onChange={handleCheckboxChange}
                        className="ms-3" 
                        />
                    ))}
                    </Dropdown.Menu>
                </Dropdown>                  
            </Col>
            <Col xs={2}>
                <Form.Select value={type} onChange={e => setType(e.target.value)}>
                    <option value="">All Types</option>
                    {subCategories.map(t => <option key={t.scheme_type_id} value={t.scheme_type_id}>{t.scheme_type_name}</option>)}
                </Form.Select>
            </Col>

            <Col xs={2}>
                <NameFilter parentSearchTerm={parentSearchTerm} parentHandleNameSearch={parentHandleNameSearch} parentClearNameSearch={parentClearNameSearch}  />
            </Col>
            <Col xs={1}>
                <Form.Select value={pageSize} onChange={e => {setPageSize(Number(e.target.value)); setCurrentPage(1);}}>
                    {[20, 35, 50].map(sz => (<option key={sz} value={sz}>{sz} / page</option>))}
                </Form.Select>
            </Col>
            <Col xs={2}>
                <Dropdown className="mx-0" style={{ width: '100%' }}>
                    <Dropdown.Toggle variant="secondary" id="dropdown-multi-select" className="w-100 text-start d-flex justify-content-between align-items-center">
                    {selLaunchGroups.length > 0 ? `${selLaunchGroups.length} LaunchGroups` : 'Select LaunchGroup(s)'}
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{ width: '100%' }}>
                    {launchGroups.map((launchGroup) => (
                        <Form.Check
                        key={launchGroup.scheme_launch_group_id}
                        type="checkbox"
                        id={`checkbox-${launchGroup.scheme_launch_group_id}`}
                        label={launchGroup.scheme_launch_group}
                        value={launchGroup.scheme_launch_group}
                        checked={selLaunchGroups.includes(launchGroup.scheme_launch_group)}
                        onChange={handleLaunchGroupChange}
                        className="ms-3" 
                        />
                    ))}
                    </Dropdown.Menu>
                </Dropdown> 
            </Col>
        </Row>
    </div>
  )
}
